import { getInstance } from './authWrapper';
import { watch } from 'vue';
import { getLocale } from '@/utils/i18nHelpers';

// eslint-disable-next-line no-unused-vars
export const authGuard = async (to, from, locale) => {
  const authService = getInstance();

  // Wait until loaded
  if (authService.loading.value) {
    await new Promise(resolve => {
      const stop = watch(
        () => authService.loading.value,
        loading => {
          if (loading === false) {
            stop();
            resolve();
          }
        }
      );
    });
  }

  if (authService.isAuthenticated.value) {
    return true; // Allow navigation
  }

  authService.loginWithRedirect({
    appState: { targetUrl: to.fullPath },
    ui_locales: getLocale().replace('_', '-'),
  });

  return false; // Prevent navigation as login will redirect
};
